import {Action, Dispatch} from 'redux';
import initialState from '../initialState';
import {NotificationActions} from './notification/notification-actions';
import {AppDispatch} from './index';
import { getApi } from '../api/ApiProvider';

export enum AdminActionTypes {
    FETCH_REQUEST = '[ADMIN][LIST] Request',
    FETCH_RESPONSE = '[ADMIN][LIST] Response',
    FETCH_ERROR = '[ADMIN][ERROR] Error',

    ADD_REQUEST = '[ADMIN][ADD] Request',
    ADD_RESPONSE = '[ADMIN][ADD] Response',
    ADD_ERROR = '[ADMIN][ADD] Error',

    DISABLE_REQUEST = '[ADMIN][DISABLE] Request',
    DISABLE_RESPONSE = '[ADMIN][DISABLE] Response',
    DISABLE_ERROR = '[ADMIN][DISABLE] Error',

    UPDATE_REQUEST = '[ADMIN][UPDATE] Request',
    UPDATE_RESPONSE = '[ADMIN][UPDATE] Response',
    UPDATE_ERROR = '[ADMIN][UPDATE] Error',

    CHANGE_PASSWORD_REQUEST = '[ADMIN][CHANGE_PASSWORD] Request',
    CHANGE_PASSWORD_RESPONSE = '[ADMIN][CHANGE_PASSWORD] Response',
    CHANGE_PASSWORD_ERROR = '[ADMIN][CHANGE_PASSWORD] Error',

    CHANGE_DRIVER_REQUEST = '[ADMIN][CHANGE_DRIVER] Request',
    CHANGE_DRIVER_RESPONSE = '[ADMIN][CHANGE_DRIVER] Response',
    CHANGE_DRIVER_ERROR = '[ADMIN][CHANGE_DRIVER] Error',
}

export interface IAdminStore {
    data: {
        fetching: boolean,
        error?: any,
        data?: any
    },
    add: {
        fetching: boolean,
        error?: any,
        data?: any
    },
    select: {
        fetching: boolean,
        error?: any,
        data?: any
    }
}

export default (state: IAdminStore = initialState.admin, action?: Action<AdminActionTypes> & { payload: any }) => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case AdminActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: {
                    fetching: true,
                    error: null,
                    data: null
                }
            };

        case AdminActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: {
                    fetching: false,
                    data: action.payload,
                    error: null
                }
            };

        case AdminActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: {
                    fetching: false,
                    data: null,
                    error: action.payload
                }
            };

        case AdminActionTypes.ADD_REQUEST:
            return {
                ...state,
                add: {fetching: true}
            };
        case AdminActionTypes.ADD_RESPONSE:
            if (state.data && state.data.data) {
                return {
                    ...state,
                    data: {data: state.data.data.concat(action.payload), fetching: false},
                    add: {fetching: false, data: action.payload}
                }
            }
            return {
                ...state,
                add: {fetching: false, data: action.payload}
            };
        case AdminActionTypes.ADD_ERROR:
            return {
                ...state,
                add: {fetching: false, error: action.payload}
            };

        case AdminActionTypes.UPDATE_REQUEST:
            return {
                ...state,
                select: {fetching: true, error: null, data: null}
            }

        case AdminActionTypes.UPDATE_ERROR:
            return {
                ...state,
                select: {fetching: false, error: action.payload, data: null}
            }

        case AdminActionTypes.UPDATE_RESPONSE:
            return {
                ...state,
                select: {fetching: false, error: null, data: action.payload}
            }

        case AdminActionTypes.CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                select: {fetching: true, error: null, data: null}
            }

        case AdminActionTypes.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                select: {fetching: false, error: action.payload, data: null}
            }

        case AdminActionTypes.CHANGE_PASSWORD_RESPONSE:
            return {
                ...state,
                select: {fetching: false, error: null, data: action.payload}
            }

        case AdminActionTypes.CHANGE_DRIVER_REQUEST:
            return {
                ...state,
                select: {fetching: true, error: null, data: null}
            }

        case AdminActionTypes.CHANGE_DRIVER_ERROR:
            return {
                ...state,
                select: {fetching: false, error: action.payload, data: null}
            }

        case AdminActionTypes.CHANGE_DRIVER_RESPONSE:
            return {
                ...state,
                select: {fetching: false, error: null, data: action.payload}
            }
            
        default:
            return state;
    }
};

export class AdminActions {

    add(data: { name: string, pass: string, email: string }) {
        return async (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({type: AdminActionTypes.ADD_REQUEST});

            await getApi().admin().add(data).then(response => {

                dispatch(notif.addSuccess('Usuario', 'Usuario agregado'));
                dispatch({type: AdminActionTypes.ADD_RESPONSE, payload: response});

            }).catch(err => {

                dispatch(notif.addError('Usuario', 'Fallo al agregar'));
                dispatch({type: AdminActionTypes.ADD_ERROR, payload: err});

            })

        }
    }

    disable(data: any) {
        return (dispatch: Dispatch) => {
            dispatch({type: AdminActionTypes.DISABLE_REQUEST});
            getApi().admin().disable(data.id).then((admin: any) => {
                dispatch({type: AdminActionTypes.DISABLE_RESPONSE, payload: data});
            }).catch(err => {
                dispatch({type: AdminActionTypes.DISABLE_ERROR, payload: err});
            })

        }
    }

    fetch() {
        return (dispatch: Dispatch) => {
            dispatch({type: AdminActionTypes.FETCH_REQUEST});
            getApi().admin().list().then(data => {
                dispatch({type: AdminActionTypes.FETCH_RESPONSE, payload: data});
            }).catch(err => {
                dispatch({type: AdminActionTypes.FETCH_ERROR, payload: err});
            })

        }
    }

    edit(data: { name: string, pass: string, email: string }, id: number) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({type: AdminActionTypes.UPDATE_REQUEST});
            getApi().admin().update(data, id).then(response => {

                dispatch(notif.addSuccess('Usuario', 'Usuario modificado'));
                dispatch({type: AdminActionTypes.UPDATE_RESPONSE, payload: response});
            }).catch(err => {

                dispatch(notif.addError('Usuario', 'Fallo al modificar'));
                dispatch({type: AdminActionTypes.UPDATE_ERROR, payload: err});

            })
        }

    }

    changePassword(id: number, password: string, onSuccess?: () => void) {
        return (dispatch: AppDispatch) => {
            const notif = new NotificationActions();

            dispatch({type: AdminActionTypes.CHANGE_PASSWORD_REQUEST});
            getApi().admin().changePassword(id, password).then(response => {
                dispatch(notif.addSuccess('Usuario', 'Password cambiado'));
                dispatch({type: AdminActionTypes.CHANGE_PASSWORD_RESPONSE, payload: response});
                if (onSuccess) {
                    onSuccess();
                }
            }).catch(err => {
                dispatch(notif.addError('Usuario', 'Fallo al cambiar el password'));
                dispatch({type: AdminActionTypes.CHANGE_PASSWORD_ERROR, payload: err});
            });
        }
    }

    changeToDriver(id: number) {
        return (dispatch: AppDispatch) => {
            dispatch({type: AdminActionTypes.CHANGE_DRIVER_REQUEST});
            getApi().admin().adminToDriver(id).then(response => {
                dispatch({type: AdminActionTypes.CHANGE_DRIVER_RESPONSE, payload: response});
            }).catch(err => {
                dispatch({type: AdminActionTypes.CHANGE_DRIVER_ERROR, payload: err});
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/admin.ts